import Contract from "slotworks/utils/contracts/contract";
import Logger from "slotworks/utils/logger";

abstract class AbstractMediator {

    constructor() {
        Logger.warn("Mediators are now deprecated. Use states instead");
    }

    public start(): Contract<any> {
        return Contract.empty();
    }

    public end() {
        // Cancel
    }

}

export default AbstractMediator;
